import { render, staticRenderFns } from "./QSwitch.vue?vue&type=template&id=127d27de&scoped=true"
import script from "./QSwitch.vue?vue&type=script&lang=js"
export * from "./QSwitch.vue?vue&type=script&lang=js"
import style0 from "./QSwitch.vue?vue&type=style&index=0&id=127d27de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127d27de",
  null
  
)

/* custom blocks */
import block0 from "./QSwitch.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports